import React, { Fragment } from "react";
import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary";

const attributesToObject = (attrs) => {
  return attrs.reduce((acc, { name, value }) => {
    return {
      ...acc,
      [name]: value,
    };
  }, {});
};

const getData = (dataId, data) => {
  const dataElement = data.find((element) => element.dataId === dataId);
  if (!dataElement) {
    return;
  }

  const { dataId: elementId, ...rest } = dataElement;
  return rest;
};

const renderChildNodes = (childNodes, data = [], componentsMap = {}) => {
  if (!childNodes) {
    return null;
  }

  return childNodes.map((node) => {
    if (node.nodeName.startsWith("#")) {
      return <Fragment key={node.dataId}>{node.value}</Fragment>;
    } else {
      const Component = withHideOnErrorBoundary(
        componentsMap[node.nodeName] || node.nodeName
      );
      return (
        <Component
          key={node.dataId}
          {...attributesToObject(node.attrs)}
          data={
            componentsMap[node.nodeName]
              ? getData(node.dataId, data)
              : undefined
          }
          children={
            node?.childNodes?.length > 0
              ? renderChildNodes(node.childNodes, data, componentsMap)
              : undefined
          }
        ></Component>
      );
    }
  });
};

export default renderChildNodes;
